import OSS from 'ali-oss'
import { getOSSToken } from '@/api/base'

const defaultOssConfig = {
  prefix: '/drl/',
  bucket: 'luban-web',
  region: 'oss-ap-southeast-1',
  baseUrl: 'https://luban-web.oss-ap-southeast-1.aliyuncs.com/drl/'
}

function normalizePrefix(prefix) {
  if (!prefix) return ''
  return prefix.startsWith('/') ? prefix.slice(1) : prefix
}

function getFileExt(fileName = '') {
  const index = fileName.lastIndexOf('.')
  return index > -1 ? fileName.slice(index) : ''
}

export function createOssFileName(file, prefix = defaultOssConfig.prefix) {
  const ext = getFileExt(file && file.name)
  const random = Math.random().toString(36).slice(2, 12)
  const timestamp = Date.now()
  return `${normalizePrefix(prefix)}${timestamp}_${random}${ext}`
}

export async function createOssClient(options = {}) {
  const config = { ...defaultOssConfig, ...options }
  const res = await getOSSToken(options.tokenParams)
  const token = res.data || res || {}

  return new OSS({
    region: config.region,
    accessKeyId: token.accessKeyId,
    accessKeySecret: token.accessKeySecret,
    stsToken: token.securityToken,
    bucket: config.bucket
  })
}

export async function uploadToOss(file, options = {}) {
  const config = { ...defaultOssConfig, ...options }
  const objectKey = options.objectKey || createOssFileName(file, config.prefix)
  const client = await createOssClient(config)
  const multipartSize = options.multipartSize || 1024 * 1024 * 2
  const partSize = options.partSize || 1024 * 1024

  if (file.size >= multipartSize) {
    await client.multipartUpload(objectKey, file, { partSize })
  } else {
    await client.put(objectKey, file)
  }

  return {
    name: file.name,
    url: `${config.baseUrl.replace(/\/$/, '')}/${objectKey.split('/').pop()}`,
    objectKey
  }
}

export async function uploadImageToOss(file, options = {}) {
  if (!file || !file.type || !file.type.startsWith('image/')) {
    throw new Error('请选择图片文件')
  }
  return uploadToOss(file, { multipartSize: Infinity, ...options })
}

export async function uploadVideoToOss(file, options = {}) {
  if (!file || !file.type || !file.type.startsWith('video/')) {
    throw new Error('请选择视频文件')
  }
  return uploadToOss(file, options)
}
